
import { useTokenBalance } from './useTokenBalance';

export const useTokens = () => {
  const { balance: tokenBalance, loading, error, refreshBalance, isInitialized } = useTokenBalance();

  const hasEnoughTokens = (requiredTokens: number) => tokenBalance >= requiredTokens;
  const isLowBalance = () => tokenBalance < 500;
  const isTokenDepleted = () => isInitialized && tokenBalance <= 0;

  return { tokenBalance, loading, error, isInitialized, isTokenDepleted, refreshBalance, hasEnoughTokens, isLowBalance };
};
